import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { styled } from "@mui/material/styles";
import Check from "@mui/icons-material/Check";
import MDButton from "components/MDButton";

import { createNewResponseRequirement } from "actions/responseRequirementActions";
import MDImageUpload from "components/MDImageUpload";
import MDFileUpload from "components/MDFileUpload";

export default function MDComplaintRequirementsStepper({
  data,
  client,
  onRequirement,
}) {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = React.useState(0);
  const [inputs, setInputs] = useState(
    data?.options?.map((item) => ({
      ...item,
      keyType: "responseRequirements",
      valueType: "",
      client: client,
      responseRequirementType: item?.complaintRequirementType,
      responseFor: item?.complaintRequirementTitle ? "complaint" : "product",
    }))
  );

  const responseRequirementCreate = useSelector(
    (state) => state.responseRequirementCreate
  );
  const { newResponseRequirement } = responseRequirementCreate;

  useEffect(() => {
    setInputs(
      data?.options?.map((item) => ({
        ...item,
        keyType: "responseRequirements",
        valueType: "",
        client: client,
        responseRequirementType: item?.complaintRequirementType,
        responseFor: item?.complaintRequirementTitle ? "complaint" : "product",
      }))
    );
  }, [data?._id, client]);

  useEffect(() => {
    if (newResponseRequirement?.length) {
      let responseIds = [];
      newResponseRequirement?.map((req) => {
        responseIds.push(req?._id);
      });
      onRequirement({
        name: inputs[0]?.keyType,
        value: responseIds,
      });
    }
  }, [newResponseRequirement?.length]);

  const handleNext = (finished) => {
    let submitInputs = [];
    inputs.map((val) => {
      submitInputs.push({
        responseRequirement: val?.valueType,
        responseRequirementType: val?.responseRequirementType,
        responseFor: val?.responseFor,
        client: client,
      });
    });
    dispatch(createNewResponseRequirement(submitInputs));
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    color: theme.palette.mode === "dark" ? theme.palette.white[700] : "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#eaeaf0",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#fff",
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      width: 10,
      height: 10,
      margin: 10,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  }));

  function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }

  const changeHandler = (e) => {
    setInputs((prevInputs) => {
      return prevInputs.map((val) => {
        if (val?.complaintRequirementTitle === e.target.name) {
          return { ...val, valueType: e.target.value };
        }
        return val;
      });
    });
  };

  const handleArrayChange = (item, step) => {
    setInputs((prevInputs) =>
      prevInputs.map((val) =>
        val?.complaintRequirementTitle === step?.complaintRequirementTitle
          ? { ...val, valueType: item?.value }
          : val
      )
    );
  };

  return (
    <MDBox>
      <MDTypography fontSize="medium" fontWeight="medium">
        Provide the following complaint requirements:
      </MDTypography>
      <MDBox bgColor="light">
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          connector={<></>}
        >
          <Step>
            {inputs?.map((step, index) => (
              <MDBox key={index}>
                <StepLabel
                  StepIconComponent={QontoStepIcon}
                  optional={
                    index === -1 ? (
                      <MDTypography variant="caption">Last step</MDTypography>
                    ) : null
                  }
                >
                  <MDTypography
                    fontSize="medium"
                    fontWeight="medium"
                    color="white"
                  >
                    {step?.complaintRequirementTitle}
                  </MDTypography>
                </StepLabel>
                <StepContent>
                  <MDBox sx={{ whiteSpace: "normal" }}>
                    <MDTypography
                      mb={1}
                      fontSize="medium"
                      fontWeight="small"
                      color="white"
                    >
                      {step?.description}
                    </MDTypography>
                    <MDTypography
                      mb={1}
                      fontSize="medium"
                      fontWeight="small"
                      color="white"
                    >
                      Requirement type: {step?.complaintRequirementType}
                    </MDTypography>
                    {step?.complaintRequirementType === "text" && (
                      <MDBox mb={2}>
                        <MDInput
                          type="text"
                          label={step?.complaintRequirementTitle}
                          placeholder={step?.complaintRequirementTitle}
                          fullWidth
                          name={step?.complaintRequirementTitle}
                          value={step?.valueType}
                          onChange={changeHandler}
                        />
                      </MDBox>
                    )}
                    {step?.complaintRequirementType === "number" && (
                      <MDBox mb={2}>
                        <MDInput
                          type="number"
                          label={step?.complaintRequirementTitle}
                          fullWidth
                          name={step?.complaintRequirementTitle}
                          value={step?.valueType}
                          onChange={changeHandler}
                        />
                      </MDBox>
                    )}
                    {step?.complaintRequirementType === "file" && (
                      <MDBox mb={2}>
                        <MDFileUpload
                          title={step?.complaintRequirementTitle}
                          uploadType={step?.responseRequirementType}
                          valueType={step?.valueType}
                          value={step?.valueType}
                          name={step?.complaintRequirementTitle}
                          onFileChange={(item) => handleArrayChange(item, step)}
                        />
                      </MDBox>
                    )}
                    {step?.complaintRequirementType === "image" && (
                      <MDBox mb={2}>
                        <MDImageUpload
                          title={step?.complaintRequirementTitle}
                          uploadType={step?.responseRequirementType}
                          valueType={step?.valueType}
                          value={step?.valueType}
                          name={step?.complaintRequirementTitle}
                          onImageChange={(item) =>
                            handleArrayChange(item, step)
                          }
                        />
                      </MDBox>
                    )}
                    {index === data?.options?.length - 1 && (
                      <MDBox sx={{ mb: 2 }}>
                        <MDButton
                          variant="contained"
                          onClick={() =>
                            handleNext(data?.options?.length === index - 1)
                          }
                          sx={{ mt: 1, mr: 1 }}
                        >
                          Submit Complaint Requirements
                        </MDButton>
                      </MDBox>
                    )}
                  </MDBox>
                </StepContent>
              </MDBox>
            ))}
          </Step>
        </Stepper>
      </MDBox>
      {newResponseRequirement?.length && (
        <MDBox sx={{ whiteSpace: "normal", p: 3 }}>
          <MDButton onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
            Reset Requirements
          </MDButton>
          <MDTypography color="success" fontSize="medium">
            Requirements submitted, complete below to make complaint:
          </MDTypography>
        </MDBox>
      )}
    </MDBox>
  );
}
